import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import FinancialManagementWidget from '../../widgets/financialManagementWidgets/FinancialManagementWidget'

export default function FinancialManagement() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const mockSchema = {
    affectedRows: 5,
    message: 'Successfully',
    success: true,
    didError: false,
    errorMessage: null,
    model: {
      header: 'การจัดการงบประมาณหลังบ้าน',
      subHeader: '',
      disabled: false,
      form: {
        DisbursementForm: {
          header: 'เบิกงวดเงิน',
          modeSap: {
            label: 'จอง/เปลี่ยนงบ SAP',
            name: 'modeSap',
            value: '',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'CREATE',
                value: '1',
              },
              {
                disabled: false,
                label: 'CHANGE',
                value: '2',
              },
              {
                disabled: false,
                label: 'DELETE',
                value: '3',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          modeEbus: {
            label: 'จอง/เปลี่ยนงบ e-Bud',
            name: 'modeEbus',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'RESERVE_REQUEST',
                value: 'RESERVE_REQUEST',
              },
              {
                disabled: false,
                label: 'RESERVE_UPDATE',
                value: 'RESERVE_UPDATE',
              },
              {
                disabled: false,
                label: 'RESERVE_REJECT',
                value: 'RESERVE_REJECT',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          modeEform: {
            label: 'จอง/เปลี่ยนแก้ไขงบ e-From',
            name: 'modeEform',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'N',
                value: 'N',
              },
              {
                disabled: false,
                label: 'C',
                value: 'C',
              },
              {
                disabled: false,
                label: 'D',
                value: 'D',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          projectCode: {
            label: 'รหัสโครงการ',
            name: 'projectCode',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายการ' }],
          },
          installment: {
            label: 'งวดที่',
            name: 'installment',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายการ' }],
          },
          mode: {
            label: 'Mode',
            name: 'mode',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายการ' }],
          },
        },
        ReimbursementForm: {
          header: 'เบิกค่าทบทวน',
          modeSap: {
            label: 'จอง/เปลี่ยนงบ SAP',
            name: 'modeSap',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'CREATE',
                value: 'CREATE',
              },
              {
                disabled: false,
                label: 'CHANGE',
                value: 'CHANGE',
              },
              {
                disabled: false,
                label: 'DELETE',
                value: 'DELETE',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          modeEbus: {
            label: 'จอง/เปลี่ยนงบ e-Bud',
            name: 'modeEbus',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'CASH_REQUEST',
                value: 'CASH_REQUEST',
              },
              {
                disabled: false,
                label: 'CASH_UPDATE',
                value: 'CASH_UPDATE',
              },
              {
                disabled: false,
                label: 'CASH_REJECT',
                value: 'CASH_REJECT',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          modeEform: {
            label: 'จอง/เปลี่ยนแก้ไขงบ e-From',
            name: 'modeEform',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'N',
                value: 'N',
              },
              {
                disabled: false,
                label: 'C',
                value: 'C',
              },
              {
                disabled: false,
                label: 'D',
                value: 'D',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          projectCode: {
            label: 'รหัสโครงการ',
            name: 'projectCode',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายการ' }],
          },
          installment: {
            label: 'งวดที่',
            name: 'installment',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายการ' }],
          },
          mode: {
            label: 'Mode',
            name: 'mode',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายการ' }],
          },
        },
        BookProjectBudgetForm: {
          header: 'จองงบโครงการ',
          modeGrantRe: {
            label: 'จองงบ',
            name: 'modeGrantRe',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'GRANT_REQUEST',
                value: 'GRANT_REQUEST',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          modeGrantPay: {
            label: 'จองแยกงวดเงิน',
            name: 'modeGrantPay',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'GRANT_PAYMENT_TEAM',
                value: 'GRANT_PAYMENT_TEAM',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          modeCommit: {
            label: 'Commit งบ',
            name: 'modeCommit',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'GRANT_COMMIT',
                value: 'GRANT_COMMIT',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          modeReject: {
            label: 'ยกเลิกการจองงบ',
            name: 'modeReject',
            optionSelected: '',
            options: [
              {
                disabled: false,
                label: 'GRANT_REJECT',
                value: 'GRANT_REJECT',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาเลือกรายการ' }],
          },
          projectCode: {
            label: 'รหัสโครงการ',
            name: 'projectCode',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายการ' }],
          },
          mode: {
            label: 'Mode',
            name: 'mode',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกรายการ' }],
          },
        },
      },
    },
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const request = {
      //   lawType: null,
      //   projectCode: null,
      //   docNumberOfPurchase: null,
      //   contractNumberRef: null,
      //   pageNumber: 1,
      //   pageSize: 5,
      // }

      // const _schema = await getLegalManagement(request)
      // console.log('getLegalManagement ', _schema)
      setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.model.header} subHeader={''} isNotCallApi />
        <FinancialManagementWidget schema={schema.model} />
        <br />
      </SidebarProposal>
    </div>
  )
}
